module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "roomChange"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.Url + _vm.query.pageDate.photoUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mesList"
  }, [_c('div', {
    staticClass: "title color-333 font-size-14px margin-top-8"
  }, [_vm._v("姓名：" + _vm._s(_vm.query.pageDate.studentName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("学号：" + _vm._s(_vm.query.pageDate.studentNo))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("学院：" + _vm._s(_vm.query.pageDate.studentCollegeName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("当前年级：" + _vm._s(_vm.query.pageDate.studentYear) + "级")])])])]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("换寝信息")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('div', {
    staticClass: "mesList"
  }, [_c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("申请时间：" + _vm._s(_vm.query.pageDate.createdDt))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("原来住址：" + _vm._s(_vm.query.pageDate.oldRoomName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("换房地址：" + _vm._s(_vm.query.pageDate.newRoomName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("换寝原因：" + _vm._s(_vm.query.pageDate.reason))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("联系电话：" + _vm._s(_vm.query.pageDate.studentPhone))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("审批材料：")]), _vm._v(" "), _c('img', {
    staticClass: "thumbnail margin-top-20",
    attrs: {
      "src": _vm.Url + _vm.query.pageDate.attrUrl
    },
    on: {
      "click": function($event) {
        return _vm.openBigImg(_vm.query.pageDate.attrUrl)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-20"
  }, [_vm._v("换房状态：" + _vm._s(_vm.query.pageDate.audit2Status))])])])])]), _vm._v(" "), (_vm.query.type == 1 && _vm.query.pageDate.audit2Status == '待审核') ? _c('div', {
    staticClass: "grid bg-appStyle color-fff footer"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1",
    staticStyle: {
      "border-right": "1px solid #fff"
    },
    on: {
      "click": function($event) {
        return _vm.handleApply('/wx/changeRoom/sq/closeApply', 'get', '1')
      }
    }
  }, [_vm._v("\n        关闭申请\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.query.type == 2 && _vm.query.pageDate.audit2Status == '待审核') ? _c('div', {
    staticClass: "grid bg-appStyle color-fff footer"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-basis-50",
    staticStyle: {
      "border-right": "1px solid #fff"
    },
    on: {
      "click": function($event) {
        return _vm.handleApply('/wx/changeRoom/audit/hqTeacherAuditSubmit', 'post', '3')
      }
    }
  }, [_vm._v("\n        同意\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-basis-50",
    staticStyle: {
      "border-right": "1px solid #fff"
    },
    on: {
      "click": function($event) {
        return _vm.handleApply('/wx/changeRoom/audit/hqTeacherAuditSubmit', 'post', '2')
      }
    }
  }, [_vm._v("\n        拒绝\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.query.type == 4) ? _c('div', {
    staticClass: "grid bg-appStyle color-fff footer"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1",
    staticStyle: {
      "border-right": "1px solid #fff"
    },
    on: {
      "click": function($event) {
        return _vm.handleApply('/wx/changeRoom/audit/doOutRoom', 'post', '4')
      }
    }
  }, [_vm._v("\n        确认搬出\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.query.type == 5) ? _c('div', {
    staticClass: "grid bg-appStyle color-fff footer"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1",
    staticStyle: {
      "border-right": "1px solid #fff"
    },
    on: {
      "click": function($event) {
        return _vm.handleApply('/wx/changeRoom/audit/doInRoom', 'post', '5')
      }
    }
  }, [_vm._v("\n        确认搬入\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.showImgModal) ? _c('div', {
    staticClass: "imgModal",
    on: {
      "click": function($event) {
        return _vm.closeImg()
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.Url + _vm.query.pageDate.attrUrl
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-358f291e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RoomChangeDetial.vue
// module id = 845
// module chunks = 1